
export const defaultConfiguration = {
    titleClosed: 'Click to chat!',
    titleOpen: 'Let\'s chat!',
    closedStyle: 'chat', // button or chat
    closedChatAvatarUrl: '', // only used if closedStyle is set to 'chat'
    cookieExpiration: 1, // in days. Once opened, closed chat title will be shown as button (when closedStyle is set to 'chat')
    introMessage: 'Welcome to Derisnap, How can i help you?',
    autoResponse: 'Looking for the first available admin (It might take a minute)',
    autoNoResponse: `
        <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px; color: #333; max-width: 350px; margin: 0 auto; line-height: 1.6;">
            <p style="margin-bottom: 18px;">
            Hello! We're currently away but still eager to assist you.
            </p>

            <p style="margin-bottom: 12px;">
            📧 Feel free to email us at&nbsp;
            <a href="mailto:support@derisnap.com" style="color: #0066cc; text-decoration: none;" target="_blank" rel="noopener noreferrer">
                support@derisnap.com
            </a>
            &nbsp;and we'll get back to you as soon as possible.
            </p>

            <p style="margin-bottom: 20px;">
            🌐 For more ways to connect, visit our&nbsp;
            <a href="https://trade.derisnap.com/connect-with-us" target="_blank" rel="noopener noreferrer" style="color: #0066cc; text-decoration: none;">
                Connect page
            </a>.
            </p>

            <p style="margin-bottom: 10px;">
            📲 Scan the QR code below to connect with us across social media:
            </p>

            <div style="text-align: center;">
            <img 
                src="../../media/social_media.png" 
                alt="Social Media QR Code" 
                width="140" 
                style="border-radius: 10px; user-select: none; pointer-events: none;" 
                oncontextmenu="return false;" 
                draggable="false" 
            />
            </div>
        </div>`,
    placeholderText: 'Send a message...',
    displayMessageTime: true,
    mainColor: '#2baaf8',
    alwaysUseFloatingButton: true,
    desktopHeight: 450,
    desktopWidth: 370
};



// WEBPACK FOOTER //
// ./src/widget/default-configuration.js